import request from "../helpers/request";

function upload(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "mutipart/form-data" })
    .build()
    .post(`/v1/transmission/upload`, params, { ...config });
}

function fetchMicrowaveList(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/transmission/Microway`, params, { ...config });
}

function fetchNEList(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/transmission/NE`, params, { ...config });
}
function downloadMicrowave(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/transmission/microway`, params, { ...config });
}
function downloadMicrowave_Coustom(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/transmission/microway_coustom`, params, { ...config });
}
function downloadPla_Coustom(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/transmission/pla_coustom`, params, { ...config });
}
function downloadMicrowaveFile(params, config) {
  console.log(params)
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "mutipart/form-data" })
    .build()
    .post(`/v1/transmission/micro_upload`, params, { ...config });
}

function downloadPLA(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/transmission/pla`, params, { ...config });
}
function downloadLTP(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/transmission/ltp`, params, { ...config });
}
function downloadNE(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/transmission/ereport`, params, { ...config });
}

function fetchRegions(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .get(`/v1/transmission/regions`, data, { ...config });
}

function fetchProvinces(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .get(`/v1/transmission/provines`, data, { ...config });
}

function fetchCities(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .get(`/v1/transmission/cities`, data, { ...config });
}

function fetchDeviceName(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .get(`/v1/transmission/DeviceName`, data, { ...config });
}

function fetchResourceName(data, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
    .build()
    .get(`/v1/transmission/ResourceName`, data, { ...config });
}

function viewDashboard(data, config) {
  // return request
  // request
  //   .forBaseUrl()
  //   .withHeaders({ "Content-Type": "application/x-www-form-urlencoded" })
  //   .build()
  //   .get(`/v1/transmission/dashboard`, data, { ...config });

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: [
          {
            name: "Germany",
            y: 357022,
            color: "#2F5EC4",
          },
          {
            name: "Italy",
            y: 301340,
            color: "#45a5f5",
          },
          {
            name: "Switzerland",
            y: 41277,
            color: "#BF0B23",
          },
        ],
      });
    }, 2000);
  });
}
const baseUrl = "/v1/transmission";
function Post(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function Get(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config });
}
function PostBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
function GetBlob(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`${baseUrl}${address}`, params, { ...config, responseType: "blob" });
}
const transmissionService = {
  Get,
  Post,
  PostBlob,
  GetBlob,
  upload,
  fetchMicrowaveList,
  fetchNEList,
  downloadMicrowave,
  downloadPLA,
  downloadNE,
  fetchRegions,
  fetchProvinces,
  fetchCities,
  fetchDeviceName,
  fetchResourceName,
  viewDashboard,
  downloadMicrowaveFile,
  downloadLTP,
  downloadMicrowave_Coustom,
  downloadPla_Coustom
};


export default transmissionService;
